import { render, staticRenderFns } from "./former.vue?vue&type=template&id=b90f6808&scoped=true&"
import script from "./former.vue?vue&type=script&lang=js&"
export * from "./former.vue?vue&type=script&lang=js&"
import style0 from "./former.vue?vue&type=style&index=0&id=b90f6808&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90f6808",
  null
  
)

export default component.exports